import { TitleHelpIconTooltip } from 'App/Map/PanelDetails/SectionTitleBars/TitleHelpIconTooltip/TitleHelpIconTooltip'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

type TPowderyMildewCrop = 'cherry' | 'grape'

const powderyMildewTemperatureRange: Record<TPowderyMildewCrop, { low: number; high: number }> = {
  cherry: {
    low: 15,
    high: 27.4,
  },
  grape: {
    low: 21.1,
    high: 29.4,
  },
}

export const PowderyMildewTooltip = ({ crop }: { crop: TPowderyMildewCrop }) => {
  return (
    <TitleHelpIconTooltip>
      <div
        style={{
          maxWidth: 'min(90vw, 430px)',
          textAlign: 'center',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          fontWeight: 'normal',
        }}
      >
        <p>
          {translate.phrases.banyanApp(
            'The index measures how rapidly the fungus is reproducing and is used to provide general guidelines regarding the interval between fungicide applications.',
          )}
        </p>
        <p>{translate.phrases.banyanApp('High-risk indicates shorter intervals between sprays.')}</p>
        <p>
          {translate.phrases.banyanApp(
            'Secondary infection requires 3 consecutive days with > 6 continuous hours with temperature between {{ low }} and {{ high }}.',
            {
              low: unitConverter
                .temperatureInCanopy(powderyMildewTemperatureRange[crop].low)
                .valueWithSuffix(),
              high: unitConverter
                .temperatureInCanopy(powderyMildewTemperatureRange[crop].high)
                .valueWithSuffix(),
            },
          )}
        </p>
      </div>
    </TitleHelpIconTooltip>
  )
}
